import { postApiCall } from '../utils/Api';

const createUserActivity = async (data) => {
  const result = await postApiCall(`/activity/create`, data);
  return result.data;
};

export default createUserActivity;
